import React, { useState } from 'react';
import styled from 'styled-components';

import AreaSelector from '../components/search/areaSelector';
import CategorySelector from '../components/search/categorySelector';
import SearchInput from '../components/search/searchInput';
import SearchResults from '../components/search/searchResults';

//#region Styled Components
const SearchContainer = styled.div`
  min-height: 100vh;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const SelectorContainer = styled.div`
  width: 25rem;
  height: 4.5rem;
  margin: 0 auto;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: center;
`;

const Message = styled.div`
  width: 50rem;
  height: 5rem;
  padding: 1rem;
  text-align: center;
`;

const ResultsHeader = styled.div`
  height: 9rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 10;
  box-shadow: 0 0.5px 5px 1px var(--border-main);
`;

const SearchLink = styled.a`
  color: var(--button-main);
  font-size: 1.2rem;
  cursor: pointer;
  position: fixed;
  top: 2rem;
  left: 2rem;
`;
//#endregion

const Search = ({ selectedListId }) => {
  const [searchValue, setSearchValue] = useState('');
  const [searchResults, setSearchResults] = useState(null);
  const [selectedArea, setSelectedArea] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [showResults, setShowResults] = useState(false);

  const getResults = async searchTerm => {
    try {
      let parser = new DOMParser();
      const response = await fetch(
        `https://cors-anywhere.herokuapp.com/https://${selectedArea}.craigslist.org/search/${selectedCategory}?query=${searchTerm}&hasPic=1`
      );
      const text = await response.text();
      const html = parser.parseFromString(text, 'text/html');
      const htmlByClass = html.getElementsByClassName('rows');

      let results = [];
      for (let match of htmlByClass[0].children) {
        if (match.tagName === 'H4') {
          break;
        }
        results.push(match);
      }
      return results;
    } catch (error) {
      throw error;
    }
  };

  const searchCL = async () => {
    if (!selectedArea.length) return window.alert('Please select an area!');
    if (!selectedCategory.length)
      return window.alert('Please select a category!');
    if (!searchValue) return;

    setShowResults(false);
    const results = await getResults(searchValue);
    setSearchResults(results);
    setShowResults(true);
  };

  function clearSearch() {
    setShowResults(false);
    setSearchResults(null);
    setSearchValue('');
  }

  const searchUi = (
    <>
      <SelectorContainer>
        <Message>
          <h3>
            (Update: CraigsList blocked me, so this app is currently not
            working)
          </h3>
        </Message>
        <AreaSelector
          selectedArea={selectedArea}
          setSelectedArea={setSelectedArea}
        />
        <CategorySelector
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
        />
      </SelectorContainer>
      <SearchInput
        value={searchValue}
        changed={setSearchValue}
        search={searchCL}
      />
    </>
  );

  const resultsUi = (
    <>
      <ResultsHeader>
        <SearchLink onClick={clearSearch} to="/">
          &lt; Back to Search
        </SearchLink>
      </ResultsHeader>
      <SearchResults selectedListId={selectedListId} results={searchResults} />
    </>
  );

  return (
    <SearchContainer>{!showResults ? searchUi : resultsUi}</SearchContainer>
  );
};

export default Search;
